import {useTheme} from '@mui/material';

export default function NavigationActiveIcon() {
	const theme = useTheme();
	return (
		<div className="w-full">
			<svg className="w-full" width="131" height="25" viewBox="2 0 133 25" fill="none"
			     xmlns="http://www.w3.org/2000/svg">
				<g filter="url(#filter0_d_4_40)">
					<path
						d="M7.71453 23.5H7.07426C7.03325 23.5 7 23.5332 7 23.5743C7 27.6754 10.3246 31 14.4257 31H120.574C124.675 31 128 27.6754 128 23.5743C128 23.5332 127.967 23.5 127.926 23.5H127.285C117.992 23.5 108.787 21.687 100.188 18.1625L92.0904 14.8437C84.2866 11.6453 75.9338 10 67.5 10C59.0662 10 50.7134 11.6453 42.9096 14.8437L34.8119 18.1625C26.2125 21.687 17.0081 23.5 7.71453 23.5Z"
						fill={theme.palette.mode === 'light' ? 'white' : theme.palette.background.default}/>
					<path opacity="0.5"
					      d="M10.75 29.75H20.4889C21.3798 29.75 22.2622 29.5762 23.0866 29.2383L43.0044 21.075C50.7781 17.8889 59.0987 16.25 67.5 16.25C75.9013 16.25 84.2219 17.8889 91.9956 21.075L111.913 29.2383C112.738 29.5762 113.62 29.75 114.511 29.75H124.25C126.183 29.75 127.75 31.317 127.75 33.25C127.75 35.183 126.183 36.75 124.25 36.75H10.75C8.817 36.75 7.25 35.183 7.25 33.25C7.25 31.317 8.817 29.75 10.75 29.75Z"
					      stroke="url(#paint0_linear_4_40)" strokeWidth="0.5"/>
				</g>
				<defs>
					<filter id="filter0_d_4_40" x="0" y="0" width="135" height="41" filterUnits="userSpaceOnUse"
					        colorInterpolationFilters="sRGB">
						<feFlood floodOpacity="0" result="BackgroundImageFix"/>
						<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						               result="hardAlpha"/>
						<feOffset dy="-3"/>
						<feGaussianBlur stdDeviation="3.5"/>
						<feComposite in2="hardAlpha" operator="out"/>
						<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
						<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4_40"/>
						<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4_40" result="shape"/>
					</filter>
					<linearGradient id="paint0_linear_4_40" x1="67.5" y1="16" x2="67.8721" y2="31.0074"
					                gradientUnits="userSpaceOnUse">
						<stop stopColor={theme.palette.primary.main}/>
						<stop offset="0.869792" stopColor={theme.palette.primary.main} stopOpacity="0"/>
					</linearGradient>
				</defs>
			</svg>
		</div>
	);
}
